
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const DeleteButton = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.deleteImportShipmentDSR(props.data);
    };

    return (
        <div className="map-icon-component">
			{/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
            <button onClick={handleRouteClick} className="btn btn-danger" title="Delete" style={{padding:"0px 0px 9px 0px",width: "97px"}}>Delete </button>
       
        </div>
    );
};

export default DeleteButton;
